var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2962_5598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 33C28.0751 33 33 28.0751 33 22C33 15.9249 28.0751 11 22 11C15.9249 11 11 15.9249 11 22C11 28.0751 15.9249 33 22 33Z",
    fill: "#667080"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3537 25.9999H18.4042C18.297 25.9999 18.1942 25.9547 18.1184 25.8742C18.0426 25.7936 18 25.6844 18 25.5706V19.0016C18 18.8877 18.0426 18.7785 18.1184 18.698C18.1942 18.6175 18.297 18.5723 18.4042 18.5723H26.3672C26.4744 18.5723 26.5772 18.6175 26.653 18.698C26.7288 18.7785 26.7714 18.8877 26.7714 19.0016V25.5849C26.7652 25.6978 26.7184 25.8038 26.6406 25.881C26.5629 25.9583 26.4602 26.0008 26.3537 25.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3537 25.4276H18.4042C18.297 25.4276 18.1942 25.3824 18.1184 25.3019C18.0426 25.2214 18 25.1122 18 24.9983V18.4293C18 18.3155 18.0426 18.2063 18.1184 18.1258C18.1942 18.0452 18.297 18 18.4042 18H26.3672C26.4744 18 26.5772 18.0452 26.653 18.1258C26.7288 18.2063 26.7714 18.3155 26.7714 18.4293V25.0126C26.7652 25.1255 26.7184 25.2315 26.6406 25.3088C26.5629 25.386 26.4602 25.4286 26.3537 25.4276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7246 18.5879H26.2863V19.2176H19.7246V18.5879Z",
    fill: "#667080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8485 19.4032C19.109 19.4032 19.3201 19.1789 19.3201 18.9023C19.3201 18.6256 19.109 18.4014 18.8485 18.4014C18.5881 18.4014 18.377 18.6256 18.377 18.9023C18.377 19.1789 18.5881 19.4032 18.8485 19.4032Z",
    fill: "#667080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4717 19.832H26.2865V24.8553H18.4717V19.832Z",
    fill: "#667080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1198 22.8809L23.0928 22.9667L23.0255 23.1671L22.8503 23.0812L22.7694 23.0383L22.729 23.1098L22.6078 23.2816L22.4596 23.1528L22.3922 23.0955L22.3383 23.1528L22.1766 23.2816L22.0688 23.1098L22.0284 23.0383L21.9475 23.0812L21.7724 23.1671L21.705 22.9667L21.6781 22.8809L21.5433 22.9095H21.4355V24.4837L22.3787 23.6394L23.3219 24.4837V22.9095H23.2276L23.1198 22.8809Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6057 21.549L23.7674 21.3629L23.5653 21.2198L23.6731 20.9908L23.444 20.905L23.4979 20.6617L23.2554 20.633L23.2419 20.3897L22.9994 20.4327L22.932 20.2037L22.7164 20.3039L22.5817 20.1035L22.3931 20.2609L22.2179 20.1035L22.0832 20.3039L21.8676 20.2037L21.7868 20.4327L21.5577 20.3897L21.5442 20.633L21.3017 20.6617L21.3421 20.905L21.1265 20.9908L21.2209 21.2198L21.0322 21.3629L21.1804 21.549L21.0322 21.735L21.2209 21.8781L21.1265 22.1071L21.3421 22.193L21.2748 22.4363L21.4634 22.4649H21.5038L21.5442 22.7082L21.7868 22.6653L21.8676 22.9086L22.0832 22.7941L22.2179 23.0087L22.3931 22.837L22.5817 23.0087L22.7164 22.7941L22.932 22.9086L22.9994 22.6653L23.2419 22.7082L23.2689 22.4649H23.2823L23.4979 22.4363L23.444 22.193L23.6731 22.1071L23.5653 21.8781L23.7674 21.735L23.6057 21.549Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1633 21.693L21.8265 21.3066L21.4492 21.7074L22.1499 22.4515L23.3355 21.1921L23.0661 20.8916L22.1633 21.693Z",
    fill: "#667080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2962_5598",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.6 0 0 0 0 0.705882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2962_5598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2962_5598",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrc);
export default __webpack_public_path__ + "static/media/trc.551b9af66d4c9a0ad41f21f79320b1fd.svg";
export { ForwardRef as ReactComponent };